import { TeamTypesEnum } from 'types/generated/client';

/**
 * A pickup game's format. Singles and doubles map 1:1 to `event_groups.team_type`;
 * Open Play is the NULL team type — no fixed team composition, with the head
 * count on `events.participant_limit` instead.
 */
export enum GameFormat {
  Singles = 'SINGLES',
  Doubles = 'DOUBLES',
  OpenPlay = 'OPEN_PLAY',
}

export const GAME_FORMAT_LABELS: Record<GameFormat, string> = {
  [GameFormat.Singles]: 'Singles',
  [GameFormat.Doubles]: 'Doubles',
  [GameFormat.OpenPlay]: 'Open Play',
};

export const GAME_FORMAT_OPTIONS: { label: string; value: GameFormat }[] = Object.values(
  GameFormat,
).map((value) => ({ label: GAME_FORMAT_LABELS[value], value }));

export const getGameFormat = (teamType: TeamTypesEnum | null | undefined): GameFormat => {
  if (teamType === TeamTypesEnum.Singles) return GameFormat.Singles;
  if (teamType === TeamTypesEnum.Doubles) return GameFormat.Doubles;
  return GameFormat.OpenPlay;
};

export const teamTypeForFormat = (format: GameFormat): TeamTypesEnum | null => {
  if (format === GameFormat.Singles) return TeamTypesEnum.Singles;
  if (format === GameFormat.Doubles) return TeamTypesEnum.Doubles;
  return null;
};

/** Seats per side for the two-sided formats; null for Open Play (one open roster). */
export const getPlayersPerTeam = (format: GameFormat): number | null => {
  if (format === GameFormat.Singles) return 1;
  if (format === GameFormat.Doubles) return 2;
  return null;
};

/** An Open Play with no head count: seats never run out. */
export const isUnlimitedOpenPlay = (game: {
  format: GameFormat;
  participantLimit?: number | null;
}): boolean => game.format === GameFormat.OpenPlay && game.participantLimit == null;
